import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, createElementVNode } from "vue";
import { _export_sfc } from "../WAccordion/index.js";
import './index.css';const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "WSkeleton",
  props: {
    set: { default: "black" },
    animated: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    const classes = computed(() => [
      `--set-${props.set}`,
      {
        "--animated": props.animated
      }
    ]);
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["w-skeleton", classes.value])
      }, _cache[0] || (_cache[0] = [
        createElementVNode("div", { class: "w-skeleton__wave" }, null, -1)
      ]), 2);
    };
  }
});
const WSkeleton = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-dd7e9dd7"]]);
export {
  WSkeleton
};
